import { formatCurrency } from "@sellar-io/common";
import { ProgressBarIndigo } from "../../progressBar/ProgressBar";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { useMinimumOrderPriceRequirement } from "~/hooks/usePriceTierOrderRequirements";
import { Icon } from "@sellar-io/components";

export function MinimumOrderPriceProgress({
  minimumOrderPrice,
  price,
  hideWhenMet,
  currency,
}: {
  minimumOrderPrice: number;
  price?: number;
  hideWhenMet?: boolean;
  currency: SupplierGetResponseType["currency"];
}) {
  const { percentageComplete: percentage, state } =
    useMinimumOrderPriceRequirement({ minimumOrderPrice, price, currency });

  if (state === "description") {
    return (
      <>
        {`Minimum order total of ${formatCurrency(
          minimumOrderPrice,
          currency,
        )}`}
      </>
    );
  }

  if (state === "met") {
    if (hideWhenMet) {
      return null;
    }
    return (
      <div className={"flex gap-1 text-indigo-800"}>
        <Icon icon={"CHECK_CIRCLE"} />
        <strong>
          Minimum order total of {formatCurrency(minimumOrderPrice, currency)}{" "}
          met!
        </strong>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className={"text-indigo-800"}>
        Spend{" "}
        <strong>
          {formatCurrency(minimumOrderPrice - (price ?? 0), currency)} more
        </strong>{" "}
        to meet minimum order total
      </div>
      <ProgressBarIndigo percentage={percentage} />
    </div>
  );
}
